import { render } from "./productsList.vue?vue&type=template&id=c7c0870a&scoped=true"
import script from "./productsList.vue?vue&type=script&lang=js"
export * from "./productsList.vue?vue&type=script&lang=js"

import "./productsList.vue?vue&type=style&index=0&id=c7c0870a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c0870a"]])

export default __exports__